var appUrl = 'https://veil.huskiapps.com';
var shopname = Shopify.shop;

// Load main loader asynchronously
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', Veil_mainLoader);
} else {
    Veil_mainLoader();
}

// detect shopify theme name
function Veil_getShopifyThemeName() {
    try {
        if (window.BOOMR !== undefined && window.BOOMR.themeName !== undefined && window.BOOMR.themeName.length > 0) {
            return window.BOOMR.themeName.toLowerCase();
        } else {
            return Shopify.theme.name.toLowerCase();
        }
    } catch (err) {
        return "";
    }
}

function Veil_mainLoader() {
    window.VEIL_THEMENAME = Veil_getShopifyThemeName();
    if (location.pathname.indexOf('/products') > -1) {
        let productid = null;
        const productdiv = document.getElementById('veil_productid');
        if (productdiv) {
            productid = productdiv.getAttribute('value');
        }
        else {
            productid = ShopifyAnalytics.meta.product.id;
        }
        const data = localStorage.getItem('veil-' + productid);
        if (data) {
            Veil_mainfunction(JSON.parse(data));
        }
        else {
            Veil_mainLoader2(productid);
        }
    }
    else {
        if (location.pathname.indexOf('/collections') == -1) {
            const productdiv = document.querySelector('[name=product-id]');
            if (productdiv) {
                let productid = productdiv.getAttribute('value');
                const data = localStorage.getItem('veil-' + productid);
                if (data) {
                    Veil_mainfunction(JSON.parse(data));
                }
                else {
                    Veil_mainLoader2(productid);
                }
            }
        }
    }

    if (window.VEIL_THEMENAME.includes('minimog')) {
        let productid = document.querySelector('.sf-modal form [name=product-id]');
        setInterval(() => {
            let newproductid = document.querySelector('.sf-modal form [name=product-id]');
            let newvariantid = document.querySelector('.sf-modal form [name=id]');
            if (productid != newproductid) {
                if (newproductid && newvariantid) {
                    productid = newproductid;
                    window.QUICK_PRODUCTID = newproductid.value;
                    window.QUICK_VARIANTID = newvariantid.value;
                    const data = localStorage.getItem('veil-' + window.QUICK_PRODUCTID);
                    if (data) {
                        Veil_mainfunction(JSON.parse(data));
                    }
                    else {
                        Veil_mainLoader2(window.QUICK_PRODUCTID, true);
                    }
                }
            }
        }, 1000);
    }

    if (window.VEIL_THEMENAME.includes('focal')) {
        let productid = document.querySelector('quick-buy-drawer[open] form [name=product-id]');
        setInterval(() => {
            let newproductid = document.querySelector('quick-buy-drawer[open] form [name=product-id]');
            let newvariantid = document.querySelector('quick-buy-drawer[open] form [name=id]');
            if (productid != newproductid) {
                if (newproductid && newvariantid) {
                    productid = newproductid;
                    window.QUICK_PRODUCTID = newproductid.value;
                    window.QUICK_VARIANTID = newvariantid.value;
                    const data = localStorage.getItem('veil-' + window.QUICK_PRODUCTID);
                    if (data) {
                        Veil_mainfunction(JSON.parse(data));
                    }
                    else {
                        Veil_mainLoader2(window.QUICK_PRODUCTID, true);
                    }
                }
            }
        }, 1000);
    }

    if (window.VEIL_THEMENAME.includes('habitat')) {
        let productid = document.querySelector('.side-panel.active form [name=product-id]');
        setInterval(() => {
            let newproductid = document.querySelector('.side-panel.active form [name=product-id]');
            let newvariantid = document.querySelector('.side-panel.active form [name=id]');
            if (productid != newproductid) {
                if (newproductid && newvariantid) {
                    productid = newproductid;
                    window.QUICK_PRODUCTID = newproductid.value;
                    window.QUICK_VARIANTID = newvariantid.value;
                    const data = localStorage.getItem('veil-' + window.QUICK_PRODUCTID);
                    if (data) {
                        Veil_mainfunction(JSON.parse(data));
                    }
                    else {
                        Veil_mainLoader2(window.QUICK_PRODUCTID, true);
                    }
                }
            }
        }, 1000);
    }

    if (window.VEIL_THEMENAME.includes('local')) {
        let productid = document.querySelector('modal-box.active form [name=product-id]');
        setInterval(() => {
            let newproductid = document.querySelector('modal-box.active form [name=product-id]');
            let newvariantid = document.querySelector('modal-box.active form [name=id]');
            if (productid != newproductid) {
                if (newproductid && newvariantid) {
                    productid = newproductid;
                    window.QUICK_PRODUCTID = newproductid.value;
                    window.QUICK_VARIANTID = newvariantid.value;
                    const data = localStorage.getItem('veil-' + window.QUICK_PRODUCTID);
                    if (data) {
                        Veil_mainfunction(JSON.parse(data));
                    }
                    else {
                        Veil_mainLoader2(window.QUICK_PRODUCTID, true);
                    }
                }
            }
        }, 1000);
    }

    if (window.VEIL_THEMENAME.includes('flex')) {
        let productid = document.querySelector('.fancybox-container.fancybox-is-open form [name=product-id]');
        setInterval(() => {
            let newproductid = document.querySelector('.fancybox-container.fancybox-is-open form [name=product-id]');
            let newvariantid = ShopifyAnalytics.meta.selectedVariantId;
            if (productid != newproductid) {
                if (newproductid) {
                    productid = newproductid;
                    window.QUICK_PRODUCTID = newproductid.value;
                    window.QUICK_VARIANTID = newvariantid;
                    const data = localStorage.getItem('veil-' + window.QUICK_PRODUCTID);
                    if (data) {
                        Veil_mainfunction(JSON.parse(data));
                    }
                    else {
                        Veil_mainLoader2(window.QUICK_PRODUCTID, true);
                    }
                }
            }
        }, 1000);
    }
}

async function Veil_mainLoader2(productid, quickview = false) {
    try {
        const response = await fetch(`${appUrl}/api/getsettingdata?shop_name=${shopname}&productid=${productid}`);
        if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
        }
        const responseData = await response.json();
        if (responseData !== 'null') {
            window.VEIL_SETTINGSDATA = responseData.setting;
            if (quickview && responseData.setting.showquickview == 'true') {
                Veil_mainfunction(responseData, true);
            }
            else {
                Veil_mainfunction(responseData);
            }
            localStorage.setItem('veil-' + productid, JSON.stringify(responseData));
        }
    } catch (error) {
        console.error('Error fetching data:', error);
    }
}

function Veil_mainfunction(data, quickview = false) {
    window.VEIL_SETTINGSDATA = data.setting;
    let classname = null;
    if (window.VEIL_SETTINGSDATA.variantaction === 'strikedisable') {
        classname = 'hide-veil-disable';
    }
    else if (window.VEIL_SETTINGSDATA.variantaction === 'strikethrough') {
        classname = 'hide-veil-disable1';
    }
    else if (window.VEIL_SETTINGSDATA.variantaction === 'hide') {
        classname = 'hide-veil-disable2';
    }

    let classname2 = null;
    if (window.VEIL_SETTINGSDATA.hideunavailable == 'true') {
        classname2 = 'hide-unavailable-veil-disable2';
    }
    else {
        if (window.VEIL_SETTINGSDATA.variantaction === 'strikedisable') {
            classname2 = 'hide-unavailable-veil-disable';
        }
        else if (window.VEIL_SETTINGSDATA.variantaction === 'strikethrough') {
            classname2 = 'hide-unavailable-veil-disable1';
        }
        else if (window.VEIL_SETTINGSDATA.variantaction === 'hide') {
            classname2 = 'hide-unavailable-veil-disable2';
        }
    }

    let optionslength = data.productdata.options.length;
    if (optionslength == 1) {
        data.optionsarray.forEach(element => {
            Veil_hideonevariant(element, classname);
        });
    }
    else if (optionslength == 2) {
        Object.entries(data.optionsarray).forEach(([key, value]) => {
            Veil_hidetwovariant(key, value, classname, data.productdata);
        });
    }
    else if (optionslength == 3) {
        Object.entries(data.optionsarray).forEach(([key, value]) => {
            Veil_hidethreevariant(key, value, classname, data.productdata);
        });
    }

    let unavailablearray = data.unavailablearray;
    if (optionslength == 1) {
        if (unavailablearray.length === undefined) {
            unavailablearray = Object.values(unavailablearray); // Convert object values to array
        }
        unavailablearray.forEach(element => {
            Veil_hideonevariant(element, classname2);
        });
    }
    else if (optionslength == 2) {
        Object.entries(unavailablearray).forEach(([key, values]) => {
            if (values.length === undefined) {
                let array = Object.values(values); // Convert object values to array
                unavailablearray[key] = array;
            }
        })

        Object.entries(unavailablearray).forEach(([key, value]) => {
            Veil_hidetwovariant(key, value, classname2, data.productdata);
        });
    }
    else if (optionslength == 3) {
        Object.entries(unavailablearray).forEach(([ke, values]) => {
            Object.entries(values).forEach(([key, value]) => {
                if (value.length === undefined) {
                    let array = Object.values(value); // Convert object values to array
                    unavailablearray[ke][key] = array;
                }
            })
        })

        Object.entries(unavailablearray).forEach(([key, value]) => {
            Veil_hidethreevariant(key, value, classname2, data.productdata);
        });
    }

    if (window.VEIL_THEMENAME.includes('minimog') || window.VEIL_SETTINGSDATA.themename == 'Minimog') {
        window.VARIANT_ID = document.querySelector('[name=id]').value;
    }
    else {
        window.VARIANT_ID = ShopifyAnalytics.meta.selectedVariantId;
    }

    setInterval(() => {
        if (quickview) {
            let currentParamValue = null;
            if (window.VEIL_THEMENAME.includes('focal') || window.VEIL_SETTINGSDATA.themename == 'Focal') {
                currentParamValue = document.querySelector('quick-buy-drawer[open] form [name=id]');
            }
            else if (window.VEIL_THEMENAME.includes('minimog') || window.VEIL_SETTINGSDATA.themename == 'Minimog') {
                currentParamValue = document.querySelector('.sf-modal form [name=id]');
            }
            else if (window.VEIL_THEMENAME.includes('habitat') || window.VEIL_SETTINGSDATA.themename == 'Habitat') {
                currentParamValue = document.querySelector('.side-panel.active form [name=id]');
            }
            else if (window.VEIL_THEMENAME.includes('local') || window.VEIL_SETTINGSDATA.themename == 'Local') {
                currentParamValue = document.querySelector('modal-box.active form [name=id]');
            }
            else if (window.VEIL_THEMENAME.includes('flex') || window.VEIL_SETTINGSDATA.themename == 'Flex') {
                currentParamValue = ShopifyAnalytics.meta.selectedVariantId;
            }
            if (currentParamValue) {
                if (window.VEIL_THEMENAME.includes('flex') || window.VEIL_SETTINGSDATA.themename == 'Flex') {
                    if (currentParamValue != window.QUICK_VARIANTID) {
                        Veil_removevariants(classname);
                        Veil_removevariants(classname2);
                        window.QUICK_VARIANTID = currentParamValue;
                        Veil_synchidevariant(optionslength, data, unavailablearray, classname, classname2);
                    }
                }
                else {
                    if (currentParamValue.value != window.QUICK_VARIANTID) {
                        Veil_removevariants(classname);
                        Veil_removevariants(classname2);
                        window.QUICK_VARIANTID = currentParamValue.value;
                        Veil_synchidevariant(optionslength, data, unavailablearray, classname, classname2);
                    }
                }
            }
        }
        else {
            let currentParamValue = null;
            if (window.VEIL_THEMENAME.includes('minimog') || window.VEIL_SETTINGSDATA.themename == 'Minimog') {
                currentParamValue = document.querySelector('[name=id]').value;
            }
            else {
                currentParamValue = ShopifyAnalytics.meta.selectedVariantId;
            }
            if (currentParamValue != window.VARIANT_ID) {
                Veil_removevariants(classname);
                Veil_removevariants(classname2);
                window.VARIANT_ID = currentParamValue;
                Veil_synchidevariant(optionslength, data, unavailablearray, classname, classname2);
            }
        }
        Veil_synchidevariant(optionslength, data, unavailablearray, classname, classname2);
    }, 500);


    setInterval(() => {
        Veil_removevariants(classname2);
        if (optionslength == 1) {
            unavailablearray.forEach(element => {
                Veil_hideonevariant(element, classname2);
            });
        }
        else if (optionslength == 2) {
            Object.entries(unavailablearray).forEach(([key, value]) => {
                Veil_hidetwovariant(key, value, classname2, data.productdata);
            });
        }
        else if (optionslength == 3) {
            Object.entries(unavailablearray).forEach(([key, value]) => {
                Veil_hidethreevariant(key, value, classname2, data.productdata);
            });
        }
    }, 1000);
  
}

function Veil_synchidevariant(optionslength, data, unavailablearray, classname, classname2) {
    if (optionslength == 1) {
        data.optionsarray.forEach(element => {
            Veil_hideonevariant(element, classname);
        });
        unavailablearray.forEach(element => {
            Veil_hideonevariant(element, classname2);
        });
    }
    else if (optionslength == 2) {
        Object.entries(data.optionsarray).forEach(([key, value]) => {
            Veil_hidetwovariant(key, value, classname, data.productdata);
        });
        Object.entries(unavailablearray).forEach(([key, value]) => {
            Veil_hidetwovariant(key, value, classname2, data.productdata);
        });
    }
    else if (optionslength == 3) {
        Object.entries(data.optionsarray).forEach(([key, value]) => {
            Veil_hidethreevariant(key, value, classname, data.productdata);
        });
        Object.entries(unavailablearray).forEach(([key, value]) => {
            Veil_hidethreevariant(key, value, classname2, data.productdata);
        });
    }
}

function Veil_removevariants(classname) {
    let alldisableoptions = document.querySelectorAll(`.${classname}`);
    alldisableoptions.forEach(option => {
        option.classList.remove(classname);
        option.removeAttribute('disabled');
    });
}

function Veil_hidethreevariant(key, values, classname, productdata) {
    // console.log(key);
    let options = productdata.options[1].values;
    const setA = new Set(Object.keys(values));
    const setB = new Set(options);
    const arraysAreEqual = (setA.size === setB.size) && [...setA].every(value => setB.has(value));

    let secondoptions = productdata.options[2].values;
    let arraysAreEqual2 = true;
    Object.entries(values).forEach(([key, value]) => {
        let array = new Set(value);
        let array2 = new Set(secondoptions);
        let arraysAreEquals = (array.size === array2.size) && [...array].every(value => array2.has(value));
        if (!arraysAreEquals) {
            arraysAreEqual2 = false;
        }
    });

    let radio = false;
    const elements = document.querySelectorAll(`option[value="${key}"], button[value="${key}"], li[value="${key}"], input[value="${key}"], [data-value="${key}"]`);
    elements.forEach(element => {
        if (arraysAreEqual && arraysAreEqual2) {
            if (window.VEIL_SETTINGSDATA.variantaction === 'strikedisable') {
                element.setAttribute('disabled', true);
            }
            element.classList.add(classname);
            if (element.checked != undefined) {
                radio = true;
            }
        }

        if (window.VEIL_THEMENAME == 'prestige' || window.VEIL_SETTINGSDATA.themename == 'Prestige-swatches') {
            let status = element.classList.contains('is-selected');
            if (status) {
                Object.entries(values).forEach(([key, value]) => {
                    Veil_hidetwovariant(key, value, classname, productdata);
                });
            }
        }
        else if (window.VEIL_THEMENAME.includes('minimog') || window.VEIL_SETTINGSDATA.themename == 'Minimog') {
            let status = element.getAttribute('data-selected');
            if (status == 'true') {
                Object.entries(values).forEach(([key, value]) => {
                    Veil_hidetwovariant(key, value, classname, productdata);
                });
            }
        }
        else {
            if (element.checked != undefined) {
                if (element.checked == true) {
                    Object.entries(values).forEach(([key, value]) => {
                        Veil_hidetwovariant(key, value, classname, productdata);
                    });
                }
            }
            else if (element.selected != undefined) {
                if (element.selected == true) {
                    Object.entries(values).forEach(([key, value]) => {
                        Veil_hidetwovariant(key, value, classname, productdata);
                    });
                }
            }
        }
    });

    if (radio) {
        const elements2 = document.querySelectorAll(`input[value="${key}"] + span, input[value="${key}"] + label, input[value="${key}"] + div::after, [data-value="${key}"]`);
        elements2.forEach(element => {
            element.classList.add(classname);
        });
    }
}

function Veil_hidetwovariant(key, value, classname, productdata) {
    // console.log(key);
    let optionslength = productdata.options.length;
    let options = [];
    if (optionslength == 3) {
        options = productdata.options[2].values;
    }
    else if (optionslength == 2) {
        options = productdata.options[1].values;
    }
    else if (optionslength == 1) {
        options = productdata.options[0].values;
    }

    const setA = new Set(value);
    const setB = new Set(options);
    const arraysAreEqual = (setA.size === setB.size) && [...setA].every(value => setB.has(value));
    let radio = false;
    const elements = document.querySelectorAll(`option[value="${key}"], button[value="${key}"], li[value="${key}"], input[value="${key}"], [data-value="${key}"]`);
    elements.forEach(element => {
        if (arraysAreEqual) {
            if (window.VEIL_SETTINGSDATA.variantaction === 'strikedisable') {
                element.setAttribute('disabled', true);
            }
            element.classList.add(classname);
            if (element.checked != undefined) {
                radio = true;
            }
        }

        if (window.VEIL_THEMENAME == 'prestige' || window.VEIL_SETTINGSDATA.themename == 'Prestige-swatches') {
            let status = element.classList.contains('is-selected');
            if (status) {
                value.forEach(element => { Veil_hideonevariant(element, classname); })
            }
        }
        else if (window.VEIL_THEMENAME.includes('minimog') || window.VEIL_SETTINGSDATA.themename == 'Minimog') {
            let status = element.getAttribute('data-selected');
            if (status == 'true') {
                value.forEach(element => { Veil_hideonevariant(element, classname); })
            }
        }
        else {
            if (element.checked != undefined) {
                if (element.checked == true) {
                    value.forEach(element => { Veil_hideonevariant(element, classname); })
                }
            }
            else if (element.selected != undefined) {
                if (element.selected == true) {
                    value.forEach(element => { Veil_hideonevariant(element, classname); })
                }
            }
        }
    });

    if (radio) {
        const elements2 = document.querySelectorAll(`input[value="${key}"] + span, input[value="${key}"] + label, input[value="${key}"] + div::after, [data-value="${key}"]`);
        elements2.forEach(element => {
            element.classList.add(classname);
        });
    }
}

function Veil_hideonevariant(key, classname) {
    // console.log(key);
    let radio = false;
    const elements = document.querySelectorAll(`option[value="${key}"], button[value="${key}"], li[value="${key}"], input[value="${key}"], [data-value="${key}"]`);
    elements.forEach(element => {
        if (window.VEIL_SETTINGSDATA.variantaction === 'strikedisable') {
            element.setAttribute('disabled', true);
        }
        element.classList.add(classname);
        if (element.checked != undefined) {
            radio = true;
        }
    });
    if (radio) {
        const elements2 = document.querySelectorAll(`input[value="${key}"] + span, input[value="${key}"] + label, input[value="${key}"] + div::after, [data-value="${key}"]`);
        elements2.forEach(element => {
            element.classList.add(classname);
        });
    }
}
